import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateCancellationPolicy } from 'modules/settings/api';

export const useMutationUpdateCancellationPolicy = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(updateCancellationPolicy, {
    onSuccess: response => {
      successToast(t('policySuccessfullyEdited'));
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_CANCELLATION_POLICIES);
    },
    onError: () => {
      errorToast();
    },
  });
};
